import { useTheme } from '../context/ThemeContext';

export default function PageLoader() {
  const theme = useTheme();
  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      zIndex: 999,
      background: theme.background,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <style>{`@keyframes gr-spin { to { transform: rotate(360deg); } }`}</style>
      <div style={{
        width: 36,
        height: 36,
        borderRadius: '50%',
        border: `3px solid ${theme.border}`,
        borderTopColor: theme.primary,
        animation: 'gr-spin 0.75s linear infinite',
      }} />
    </div>
  );
}
